import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `vehicles/${args?.id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'vehicles',
      method: 'get',
      params: args?.params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

export default { find, list }
